// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__VzxJA","list":"BalanceDue_list__2N0Or","listRow":"BalanceDue_listRow__2uD8U","total":"BalanceDue_total__P90J5"};